import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, filter, map, switchMap, take } from 'rxjs';
import { AccountContextService } from '../services/account-context.service';

@Injectable({ providedIn: 'root' })
export class AccountBoatRedirectGuard implements CanActivate {
  constructor(private readonly accounts: AccountContextService, private readonly router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<UrlTree> {
    const accountId = route.paramMap.get('accountId');
    const boatId = route.paramMap.get('boatId');
    return this.accounts.membershipsLoaded$.pipe(
      filter(Boolean), take(1),
      switchMap(() => this.accounts.activeMemberships$.pipe(take(1))),
      map(memberships => {
        if (!accountId || !boatId || !memberships.some(member => member.accountId === accountId)) {
          return this.router.createUrlTree(['/unauthorized']);
        }
        this.accounts.setActiveAccount(accountId);
        return this.router.createUrlTree(route.data?.['maintenanceSchedules']
          ? ['/boats', boatId, 'maintenance-schedules'] : ['/boats', boatId]);
      })
    );
  }
}
